import React from "react";
import skills from "../fixtures/Skills.json";
import { About } from "../components";

const DescSkillsContainer: React.FC = () => (
  <>
    <About.Desc>
      I’m a computer Science student at ESI - Ecole nationale superieure
      d'informa- tique - Algiers , Algeria. I'm interested in computer science,
      UI/UX, software development and artificial intelligence. I am an active,
      ambitous person & excellent in working with orhers to achive a certain
      objective on time with quality.
    </About.Desc>
    <About.SubHeader>skills</About.SubHeader>
    <About.Skills>
      {skills.map((item, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <About.SkillItem main={idx < 3} key={idx}>
          {item}
        </About.SkillItem>
      ))}
    </About.Skills>
  </>
);

export default DescSkillsContainer;
